import { render, staticRenderFns } from "./ReleaseDetails.vue?vue&type=template&id=ab839214&scoped=true&"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDetails.vue?vue&type=style&index=0&id=ab839214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab839214",
  null
  
)

export default component.exports